module.exports = __webpack_public_path__ + "img/manage_fill.dc6632e1.png";